<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">

      <img 
        class="c-sidebar-brand-full"
        src="../assets/icons/logo-fullsize.png" 
        size="custom-size" 
        :height="65" 
        viewBox="0 0 556 134"
      />
      <img 
        class="c-sidebar-brand-minimized" 
        src="../assets/icons/logo-min.png" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 110 134"
      /> 
      
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="$options.nav"/>
    
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav2'

export default {
  name: 'TheSidebar',
  nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  }
}
</script>
